import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { ORing } from 'src/app/models/oring.model';
import { Observable, of } from 'rxjs';
import { ClosureDetail } from 'src/app/models';
import { ClosureSpecificationsComponent } from '../../closure-selector/closure-specifications/closure-specifications.component';
import { ClosureSpecificationsModalComponent } from '../../closure-selector/closure-specifications-modal/closure-specifications-modal.component';

@Component({
  selector: 'app-oring-detail',
  templateUrl: './oring-detail.component.html',
  styleUrls: ['./oring-detail.component.scss']
})
export class ORingDetailComponent implements OnInit {
  @Input() detail?: ORing | null;
  @Input() showLoader?: boolean;

  closureLoader$: Observable<boolean> = of(false);
  activeClosure$?: Observable<ClosureDetail | undefined>;
  closureHasDrawing$: Observable<boolean> = of(false);

  constructor(public modalService: NgbModal, private store: Store<fromStore.State>, ) { }

  ngOnInit(): void {
    this.activeClosure$ = this.store.select(fromStore.selectors.CLOSURES.selectActiveClosureDetail);
    this.closureLoader$ = this.store.select(fromStore.selectors.CLOSURES.selectLoader(fromStore.LOADERS.CLOSURES.loadingDetail));
    this.closureHasDrawing$ = this.store.select(fromStore.selectors.CLOSURES.selectClosureHasDrawing);
  }

  viewClosureModal(partNumber: string) {
    this.store.dispatch(fromStore.actions.CLOSURES.activateClosureByPartNumber({ partNumber: partNumber }));
    
    const modal = this.modalService.open(ClosureSpecificationsModalComponent, { ...environment.modalOptions, size: 'lg' });
  }
}
